import translations from './translations'

translations.add('is', {
    iAgreeToShareWithClickToPay: (cardBrand) => `Ég samþykki að deila kortaupplýsingum mínum, reikningsfangi og tölvupósti með ${cardBrand || 'Mastercard' } svo ég geti skráð mig á öruggan hátt í Click to Pay fyrir hraðari greiðslur.`,
    learnMore: 'Læra meira',
    next: 'NÆST',
    pay: 'BORGA',
    submit: 'SENDA'
})
